import { AllQuestionsContext } from 'components/CleanRooms/AllQuestions/AllQuestionsContextProvider';
import { useContext } from 'react';


export const useActionMenuItems = () => {
  const {
    seeQuestionDetails,
  } = useContext(AllQuestionsContext);

  return (row) => ([{
    label: 'See Details',
    action: () => seeQuestionDetails(row.ID),
  }, {
    label: 'See Version History',
    action: () => seeQuestionDetails(row.ID, 'versionHistory'),
  }].filter(Boolean));
};
